import {createStore} from 'vuex';
import axios from 'axios';
import {useStore} from 'vuex';
import {ref} from 'vue';
import {useRoute} from 'vue-router'
import {filter} from "core-js/internals/array-iteration";
import {inject} from 'vue';
import qs from 'qs';
import api from '@/api'


const store = createStore({
    state: {
        catalog: [],
        hotline: '',
        products: [],
        productSearch: [],
        states: [],
        productsTotal: 0,
        cart: [],
        categories: [],
        user: null,
        orders: [],
        apiUrl: process.env.VUE_APP_API_URL,
        cartOpen: false,
        paymentMethod: [],
        categoryId: null,
    },
    mutations: {
        setCatalog(state, catalog) {
            state.catalog = catalog;
        },
        setHotline(state, hotline) {
            state.hotline = hotline;
        },
        setProducts(state, products) {
            state.products = products;
        },
        setProductsFilterIds(state, productsIds) {
            state.productsIds = productsIds;
        },
        setProduct(state, product) {
            state.product = product;
        },
        setProductSearch(state, productSearch) {
            state.productSearch = productSearch;
        },
        setState(state, states) {
            state.states = states;
        },
        setBreadcrumb(state, breadcrumbs) {
            state.breadcrumbs = breadcrumbs;
        },
        setCategories(state, categories) {
            state.categories = categories;
        },
        setCart(state, { products, amount, dynamic_price }) {
            state.cart.items = products;
            state.cart.amount = amount;
            state.cart.dynamic_price = dynamic_price;
        },
        setUser(state, user) {
            state.user = user;
        },
        setOrders(state, orders) {
            state.orders = orders;
        },
        addToCart(state, product) {
            state.cart.push(product);
        },
        removeFromCart(state, productId) {
            state.cart = state.cart.filter((item) => item.id !== productId);
        },
        clearCart(state) {
            state.cart = [];
        },
        openCart(state) {
            state.cartOpen = true;
        },
        closeCart(state) {
            state.cartOpen = false;
        },
        setProductsTotal(state, productTotal) {
            state.productsTotal = productTotal
        },
        setProductsMinMax(state, productMinMax) {
            state.productsMinMax = productMinMax
        },
        setPaymentMethod(state, paymentData) {
            state.paymentMethod = paymentData
        },
        setCategoryId(state, id) {
            state.categoryId = id;
        },
    },
    actions: {
        openCart({commit}) {
            commit('openCart');
        },
        closeCart({commit}) {
            commit('closeCart');
        },

        generateCartId(length = 16) {
            let result = '';
            for (let i = 0; i < length; i++) {
                result += Math.floor(Math.random() * 10); // цифра от 0 до 9
            }
            return result;
        },

        async fetchCatalog({ commit }) {
            try {
            // Получаем список категорий (каталогов) с API
            const response = await api.get(`${this.state.apiUrl}categories`);
            // Извлекаем только массив категорий из ответа
            const categoriesArray = response.data.data || [];
            commit('setCatalog', categoriesArray);
            } catch (error) {
            console.error('Error fetching catalog:', error);
            }
        },

        async fetchHotline({ commit }) {
            try {
                // Получаем список категорий (каталогов) с API
                const response = await api.get(`${this.state.apiUrl}hotline.xml`);
                commit('setHotline', response.data);
            } catch (error) {
            console.error('Error fetching catalog:', error);
            }
        },

        async fetchProducts({ commit }, param) {
            // console.log('params', param);
            const { categoryId, filters = {}, price_range = [], sort_by = null, perPage = 1000, page } = param;
            try {
                if (!categoryId) {
                    commit('setProducts', []);
                    commit('setProductsTotal', 0);
                    return;
                }

                const params = {
                    category_id: categoryId,
                    page,
                    per_page: perPage,
                };

                if (sort_by) {
                    params.sort_by = sort_by;
                }

                // Фильтры по атрибутам
                for (const attr in filters) {
                    if (filters[attr] && filters[attr].length > 0) {
                        params[`filter[${attr}]`] = filters[attr].join(',');
                    }
                }

                // Фильтр по цене — теперь price_range это массив [min, max]
                if (price_range[0] !== undefined && price_range[0] !== '' && !isNaN(price_range[0])) {
                    params['min_price'] = price_range[0];
                }
                if (price_range[1] !== undefined && price_range[1] !== '' && !isNaN(price_range[1])) {
                    params['max_price'] = price_range[1];
                }

                const response = await api.get(`${this.state.apiUrl}products`, { params });
                // console.log(response, 'responseresponse');
                const products = response.data.data || [];
                const productsTotal = response.data.total || products.length;

                const productsArray = products.map(item => {
                    const filteredAttributes = Array.isArray(item.attributes)
                        ? item.attributes.map(attr => ({
                            id: attr.id,
                            name: attr.name,
                            value: attr.pivot?.value || attr.value,
                            type: attr.type,
                            ...attr
                        }))
                        : [];

                    return {
                        id: item.id,
                        external_id: item.external_id,
                        slug: item.slug,
                        name: item.name,
                        description: item.description,
                        image: item.image,
                        images: item.images,
                        price: item.price,
                        price_discount: item.price_discount,
                        category: item.category,
                        category_id: item.category_id,
                        lastattributes: filteredAttributes,
                        tags: item.tags,
                        stock: item.stock
                    };
                });

                const productsMinMax = { 'min': response.data['min_price'], 'max': response.data['max_price'] };
                // console.log('response.data.data', productsMinMax);

                commit('setProductsFilterIds', response.data.ids);
                commit('setProductsMinMax', productsMinMax);
                commit('setProducts', productsArray);
                commit('setProductsTotal', productsTotal);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        },

        async addToCart({ dispatch }, obj) {
            try {
                let cartId = localStorage.getItem('cart_id');

                if (!cartId) {
                   cartId = 0;
                }

                const response = await api.post(
                    `${this.state.apiUrl}cart/add`,
                    {
                        product_id: obj['id'],
                        quantity: obj['quant'],
                        cart_id: cartId// или пользователь может выбирать количество
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );

                localStorage.setItem('cart_id', response.data.cart_id);
                //
                // После добавления вызываем обновление корзины
                await dispatch('cartProduct');
            } catch (error) {
                console.error('Error adding product to basket:', error);
            }
        },

      async addToCartFast({ dispatch }, obj) {
            try {
                let cartId = localStorage.getItem('cart_id');

                // console.log(cartId, 'cartId');

                if (!cartId) {
                    console.error('Cart ID not found!');
                    return;
                }


                const response = await api.post(
                    `${this.state.apiUrl}cart/replace-item`,
                    {
                        product_id: obj['id'],
                        quantity: obj['quant'],
                        cart_id: cartId
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );

                if (response.data.cart_id) {
                    localStorage.setItem('cart_id', response.data.cart_id);
                }

                // обновляем корзину
                await dispatch('cartProduct');
            } catch (error) {
                console.error('Error adding product to basket (fast):', error);
            }
        },

        async sendOrder({commit}, data){


            // console.log("tertwertewtwer");

            // console.log(data);

            // console.log("tertwertewtwer");     // console.log("tertwertewtwer")

            const response = await api.post(`${this.state.apiUrl}checkout`, data, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    },);
        },

        async getPaymentMethod({commit}) {
            try {
                const response = await api.get(
                    `${this.state.apiUrl}service?filter[cs_type]=payment&include=text,price,media`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );

                const paymentData = response.data.data;

                // console.log(paymentData)
                commit('setPaymentMethod', paymentData);

            } catch (error) {
                console.error('Error fetching cart products:', error);
            }

        },

        async cartProduct({commit}) {
            try {

                let cartId = localStorage.getItem('cart_id');

                const response = await api.get(
                    `${this.state.apiUrl}cart?cart_id=${cartId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );

                // console.log('responseresponse', response.data['total']);

                // Если в ответе есть поле items (новый формат)
                if (Array.isArray(response.data.items)) {
                    const processedProducts = response.data.items.map(item => {
                        const product = item.product || {};
                        return {
                            ...product,
                            quantity: item.quantity,
                            overallPrice: response.data['total'] || null,
                        };
                    });

                    commit('setCart', {
                        products: processedProducts,
                        amount: response.data['amount'] || 0,
                        dynamic_price: response.data['dynamic_price'] || false,
                    });
                }
            } catch (error) {
                console.error('Error fetching cart products:', error);
            }
        },

        async fetchProductSearch({ commit }) {
        try {

            const params = {
                per_page: 200,
            };

            const response = await api.get(`${this.state.apiUrl}products`, { params });

            // console.log('response333', response);

            // Обрабатываем массив товаров из response.data.data
            const productsArray = response.data.data.map(item => {
                // Преобразуем массив атрибутов в удобный вид
                const filteredAttributes = Array.isArray(item.attributes)
                    ? item.attributes.map(attr => ({
                        id: attr.id,
                        name: attr.name,
                        value: attr.pivot?.value,
                        type: attr.type,
                        ...attr
                    }))
                    : [];

                // console.log('filteredAttributes', filteredAttributes);

                return {
                    id: item.id,
                    external_id: item.external_id,
                    slug: item.slug,
                    name: item.name,
                    description: item.description,
                    image: item.image,
                    images: item.images,
                    price: item.price,
                    price_discount: item.price_discount,
                    category: item.category,
                    category_id: item.category_id,
                    lastattributes: filteredAttributes,
                    tags: item.tags,
                    stock: item.stock,
                    type: item.type,  // добавь поле type, если оно приходит с API
                    // добавьте другие нужные поля по необходимости
                };
            });

            // console.log('productObject', productsArray);

            // Комитим обработанный товар
            commit('setProductSearch', productsArray);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        },

        // function product end
        // function category begin

        async fetchCategories({commit}, productId) {
            try {
            // Получаем список категорий (каталогов) с API
            const response = await api.get(`${this.state.apiUrl}categories`);
            // console.log('responsecat2',response);

            commit('setCategories', response);
            } catch (error) {
            console.error('Error fetching catalog:', error);
            }
        },

        // function category end
        // function user begin

        async fetchUser({commit}) {
            try {
                const response = await api.get(`${this.state.apiUrl}users/me`);
                commit('setUser', response.data);
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        },

        // function user end
        // function cart begin

        async addProductToCart({commit}, product) {
            try {
                commit('addToCart', product);
            } catch (error) {
                console.error('Error adding product to cart:', error);
            }
        },
        async removeProductFromCart({commit}, productId) {
            try {
                commit('removeFromCart', productId);
            } catch (error) {
                console.error('Error removing product from cart:', error);
            }
        },
        async clearCart({commit}) {
            try {
                commit('clearCart');
            } catch (error) {
                console.error('Error clearing cart:', error);
            }
        },
        async deleteProduct({ dispatch }, id) {
            const cartId = localStorage.getItem('cart_id');

            if (!cartId) {
                console.error('Cart ID not found!');
                return;
            }

            try {

                await api.delete(
                    `${this.state.apiUrl}cart/remove/${id}?cart_id=${cartId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );


                const response = await api.get(
                    `${this.state.apiUrl}cart?cart_id=${cartId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );

                await dispatch('cartProduct');
            } catch (error) {
                console.error('Error deleting product from cart:', error);
            }
        },
        async updateCartQuantity({ dispatch }, obj) {
            try {
                let cartId = localStorage.getItem('cart_id');

                if (!cartId) {
                    console.error('Cart ID not found!');
                    return;
                }


                await api.post(
                    `${this.state.apiUrl}cart/update`,
                    {
                        product_id: obj['id'],
                        quantity: obj['quant'], // или пользователь может выбирать количество\
                        cart_id: cartId
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );



                await dispatch('cartProduct');

            } catch (error) {
                console.error('Error fetching cart products:', error);
            }

        },

        async placeOrder({commit, state}) {
            try {
                const orderData = {
                    data: {
                        type: 'orders',
                        attributes: {
                            items: state.cart.map(item => ({
                                product_id: item.id,
                                quantity: 1, // Змінити за потребою
                            })),
                        },
                    },
                };
                const response = await api.post(`${this.state.apiUrl}orders`, orderData);
                // Очистити кошик після оформлення
                commit('clearCart');
                commit('setOrders', [...state.orders, response.data]);
            } catch (error) {
                console.error('Error placing order:', error);
            }
        },

        async fetchOrders({commit}) {
            try {
                const response = await api.post(`${this.state.apiUrl}orders`);
                commit('setOrders', response.data);
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        },

        // function order end
        async sendEmailSendpulse({ commit }, email) {

            const formData = new FormData();
            formData.append('email', email);
            let url = 'http://127.0.0.1:8000/api/';
            try {
                const response = await api.post(
                    `${url}subscription`,
                    formData,
                    {
                        withCredentials: true,
                    });

                return response.data;
            } catch (error) {
                console.error('SendPulse Subscribe Error:', error);
                throw error;
            }
        }
    },
    getters: {
        catalog: (state) => state.catalog,
        products: (state) => state.products,
        product: (state) => state.product,
        productSearch: (state) => state.productSearch,
        productsTotal: (state) => state.productsTotal,
        cart: (state) => state.cart,
        categories: (state) => state.categories,
        user: (state) => state.user,
        orders: (state) => state.orders,
        cartTotal: (state) => state.cart.reduce((total, item) => total + item.price, 0),
        isCartOpen: (state) => state.cartOpen,
        paymentMethod: (state) => state.paymentMethod,
    },
});

export default store;
